<template>
  <MainLayout>
    <!-- Menu Sub Navigation -->
    <MenuSubNavbar />
    <div class="px-6">
      <!-- Header -->
      <PageHeader
        title="Gestión de Promociones"
        subtitle="Configura promociones y descuentos para tus clientes"
      >
        <template #actions>
          <div class="flex items-center space-x-3">
            <ViewModeToggle
              :view-mode="viewMode"
              @update:view-mode="viewMode = $event"
            />
            <BaseButton @click="showCreateModal = true">
              <i class="fas fa-plus" />
              Nueva Promoción
            </BaseButton>
          </div>
        </template>
      </PageHeader>

      <!-- Content -->
      <PromotionsManager
        :show-create-modal="showCreateModal"
        :view-mode="viewMode"
        @close-modal="showCreateModal = false"
      />
    </div>
  </MainLayout>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import PromotionsManager from '@/components/settings/PromotionsManager.vue';
import MenuSubNavbar from '@/components/menu/MenuSubNavbar.vue';
import MainLayout from '@/components/layout/MainLayout.vue';
import PageHeader from '@/components/layout/PageHeader.vue';
import BaseButton from '@/components/ui/BaseButton.vue';
import ViewModeToggle from '@/components/common/ViewModeToggle.vue';

const showCreateModal = ref(false);
const viewMode = ref<'list' | 'card'>('card');
</script>
